'use client';

import { swal } from '@/lib/sweetalert';
import { getCookieValue, setCookie } from '@/utils/cookie';
import {
  SetNewsLetterModal as CommonSetNewsLetterModal,
  type SetNewsLetterModalProps,
  pickErrorMessages,
} from '@monorepo/common';
import { postNewsLetter } from '../../api/postNewsLetter';

function SetNewsLetterModal({ enableNewsLetterPermission }: { enableNewsLetterPermission: boolean }) {
  const handleSubmit = async (permission: number) => {
    await postNewsLetter({
      permission,
    });
  };

  const handleError = () => {
    swal.invalid();
  };

  const pushDataLayer = (data: Record<string, unknown>) => {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (window as any).dataLayer = (window as any).dataLayer || [];
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    const dataLayer = (window as any).dataLayer;
    dataLayer.push(data);
  };

  const props: SetNewsLetterModalProps = {
    enableNewsLetterPermission,
    onSubmit: handleSubmit,
    onError: handleError,
    getCookieValue,
    setCookie,
    pushDataLayer,
  };

  return <CommonSetNewsLetterModal {...props} />;
}

export default SetNewsLetterModal;
